import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/dave/checkouts/pyohio/static-website/node_modules/gatsby-theme-catalyst-core/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Seo = makeShortcode("Seo");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Seo title="PyOhio T-Shirts" mdxType="Seo" />
    <h1 {...{
      "id": "t-shirt-fundraiser"
    }}>{`T-Shirt Fundraiser`}</h1>
    <p>{`Order your PyOhio 2022 t-shirt and support the The Python Software Foundation. Sales will close Aug 2.`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.customink.com/fundraising/pyohio-2022",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`Buy your PyOhio 2022 t-shirt`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      